import httpClient from './httpClient';

const insertPedido = (pedido) => {    
    return httpClient.post('/AppPedido/pedido', pedido);
};

export default insertPedido;